import './App.css'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Routes } from 'react-router-dom'
import 'lazysizes'

import api from '@/api'
import Main from '@/pages/Main/Main'
import {
  addStoreBanners,
  addStoreCities,
  addStoreCity,
  addStoreFormats,
  addStoreFormatsCity,
  getStoreCity,
} from '@/store/app'

const EVENT_TYPE = 'urban'

function App() {
  const dispatch = useDispatch()
  const city = useSelector(getStoreCity)

  useEffect(() => {
    fetchCities()
      .then((r) => {
        if (r?.status === 200 && r?.data?.values?.length > 0) {
          dispatch(addStoreCities(r.data.values))
          setLocationCity(r.data.values)
        } else {
          fetchBanners().then((r) => {
            if (r?.status === 200 && r?.data?.banners?.length > 0) {
              dispatch(addStoreBanners(r.data.banners))
            }
          })
        }
      })
  }, [])

  const setLocationCity = (cities) => {
    const localStorageCity = JSON.parse(localStorage.getItem('urbanCity'))

    // правая проверка для удаления старого города в localStorage
    if (localStorageCity && Object.keys(localStorageCity).length !== 2 && cities.map((item) => item.city.id).includes(localStorageCity.city.id)) {
      const findCity = cities.find((item) => item.public_id === localStorageCity.public_id)

      if (findCity) {
        dispatch(addStoreCity(findCity))
      }
    } else {
      localStorage.removeItem('urbanCity')

      fetchLocation().then((r) => {
        if (r.status === 200) {
          const foundCity = cities.find((item) => item.city.id === r.data.info.city.id)

          if (foundCity) {
            dispatch(addStoreCity(foundCity))
          } else {
            dispatch(addStoreCity(cities[0]))
          }
        }
      })
    }
  }

  useEffect(() => {
    if (city) fetchCityData(city.public_id)
  }, [city])

  const fetchCityData = async (eventCityPublicId) => {
    try {
      const response = await api.get(`/api/event_format/event/${eventCityPublicId}`)
      if (response.data) {
        dispatch(addStoreFormats(response.data.values))
        dispatch(addStoreFormatsCity(response.data.city))

        if (response.data.city.hasOwnProperty('banners') && response.data.city?.banners?.length > 0) {
          dispatch(addStoreBanners(response.data.city.banners))
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  const fetchCities = async () => {
    try {
      return await api.get(`/api/event_city/type/${EVENT_TYPE}`)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchLocation = async () => {
    try {
      return await api.get('/api/location')
    } catch (error) {
      console.error(error)
    }
  }

  const fetchBanners = async () => {
    try {
      return await api.get(`api/event_city/banners/${EVENT_TYPE}`)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Routes>
      <Route path="/" element={<Main />} />
    </Routes>
  )
}

export default App
